import apiService from "../../../service/Api";
import { ReferralProgram } from "../types/view.referral";

export async function getReferralProgram(id: string | number) {
  const response = await apiService.get<ReferralProgram>(
    `/api/refferal-program/refferal-programs/${id}/`,
  );

  return response.data;
}
